import React, { PureComponent, useContext } from 'react';
import { Router } from 'src/routes';

import { Button, Checkbox, Input, Icon, Table } from 'antd';

import SearchOnField from 'src/components/Table/SearchOnField';
import { resetWarningCache } from 'prop-types';
import moment from 'moment';
import CONSTANTS from 'src/constants';
const url = '/company-detail/';


export default function WrappedCompanyTable({ context }) {
    const _context = useContext(context);
    return (
        <CompanyTable context={_context} />
    )
}
function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

class CompanyTable extends PureComponent {
    state = {
        isChecked: false,
    }

    handleSearch = (selectedKeys, confirm, dataIndex, focus) => {
        confirm();
        this.setState({
            searchText: selectedKeys,
            searchedColumn: dataIndex,
        });
        if (this.state.isChecked == false) {
            this.setState({
                isChecked: true
            })
        }
        else if (this.state.isChecked == true) {
            this.setState({
                isChecked: false
            })
        }
    };

    render() {
        const { self, setSelected, handleSearch, selectedRowKeys } = this.props.context;

        const columns = [
            {
                title: 'Date',
                key: 'created_at',
                dataIndex: 'created_at',
                width:'15%',
                render: value => {
                    return <span style={{fontSize:13,fontWeight:'normal', fontStyle:'italic'}}>{moment(value).format('DD-MM-YYYY')}</span>
                }
            },
            {
                title: 'Montant',
                key: 'amount',
                dataIndex: 'amount',
                width:'15%',
                render: value => {
                    return (
                        <div style={{ color: '#00C68E' }}>
                            <span style={{ fontSize: 15 }}>{value && numberWithSpaces(value)}{' '}</span>
                            <span style={{ fontSize: 8 }}>{CONSTANTS.CURRENCY}</span>
                        </div>
                    )
                }
            },
            {
                title: 'REF',
                key: 'ref',
                dataIndex: 'ref',
                width:'15%',
                render: value => {
                    return <span style={{fontSize:12,fontWeight:'normal',}}>{value}</span>
                }
            },
            {
                title: 'Emetteur',
                key: 'debitor',
                dataIndex: 'debitor.email',
                render: value => {
                    return <span style={{fontSize:12,fontWeight:'normal',}}>{value}</span>
                }
            },
            {
                title: 'Destinataire',
                key: 'creditor',
                dataIndex: 'creditor.email',
                render: value => {
                    return <span style={{fontSize:12,fontWeight:'normal',}}>{value}</span>
                }
            },
        ];
        const { context } = this.props;


        const dataSource = context.data && context.data.map(d => ({
            ...d,

        }));
        return (
            <div>
                <Table
                    columns={columns}
                    bordered={false}
                    dataSource={dataSource}
                    pagination={false}
                    onChange={(a, b, sorter) => {
                        if (Object.keys(sorter).length > 0) {
                            self.setState({
                                params: {
                                    ...self.state.params,
                                    order: sorter.order === 'ascend'
                                        ? sorter.columnKey.toString()
                                        : `-${sorter.columnKey.toString()}`
                                }
                            }, () => {
                                handleSearch()
                            })
                        } else self.setState({ params: { ...self.state.params, order: {} } });

                    }}
                />
                <a style={{ fontSize: 15,verticalAlign:'middle',textDecoration:'underline',textUnderlineOffset:5 }} href="/credit-history">  accéder à l'historique des crédits <Icon style={{fontSize:20,marginLeft:5, fontWeight:'bold',verticalAlign:'middle'}} type="right"></Icon></a>

            </div>
        );
    }
}

// export default CompanyTable;
